"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProductList = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const data_model_list_1 = require("@pandora/data-model-list");

const react_data_source_jil_1 = require("@pandora/react-data-source-jil");

const react_logger_provider_1 = require("@pandora/react-logger-provider");

const react_1 = require("react");

const LicenseGroup_1 = require("./LicenseGroup");

const Product_1 = require("./Product");

const useProductList = options => {
  const {
    getOrganizationsProducts
  } = react_data_source_jil_1.useOrganizationsProducts();
  const {
    logger
  } = react_logger_provider_1.useLogger();
  const {
    acceptLanguage,
    contractId,
    includeExpired,
    includeGroupsQuantity,
    includeInactive,
    includeLicenseAllocationInfo,
    licenseGroupLimit,
    orgId
  } = options;
  const pickedOptions = {
    acceptLanguage,
    contractId,
    includeExpired,
    includeGroupsQuantity,
    includeInactive,
    includeLicenseAllocationInfo,
    licenseGroupLimit,
    orgId
  };
  const [error, setError] = react_1.useState();
  const [data, setData] = react_1.useState();
  const [loading, setLoading] = react_1.useState(false);
  react_1.useEffect(() => {
    let isMounted = true;

    const refresh = () => __awaiter(void 0, void 0, void 0, function* () {
      setLoading(true);

      try {
        const response = yield getOrganizationsProducts(pickedOptions);

        if (response) {
          const jsonData = yield response.json();
          const items = getTransformedProducts(orgId, jsonData);
          if (!isMounted) return;
          setData(new data_model_list_1.JilModelList(Object.assign(Object.assign({}, pickedOptions), {
            headers: response.headers,
            items
          })));
        }
      } catch (e) {
        if (!isMounted) return;
        logger === null || logger === void 0 ? void 0 : logger.error(new Error(`ProductList: Failed to fetch data from back-end. Error: ${e}`));
        setError(e);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }); // Short-circuit the API call if orgID is not present


    if (orgId) {
      refresh();
    } else {
      setData(new data_model_list_1.JilModelList(Object.assign(Object.assign({}, pickedOptions), {
        items: []
      })));
    } // Prevent state updates once the provider is unmounted


    return () => {
      isMounted = false;
    };
  }, // Both "getOrganizationsProducts" and "logger" need to be omitted as they are external
  // and would be a different instance every time this component is re-rendered.
  // eslint-disable-next-line react-hooks/exhaustive-deps -- Ignore "getOrganizationsProducts" and "logger"
  [acceptLanguage, contractId, includeExpired, includeGroupsQuantity, includeInactive, includeLicenseAllocationInfo, licenseGroupLimit, orgId]);
  return {
    data,
    error,
    loading
  };
};

exports.useProductList = useProductList;
/**
 * @description generates a API response data transformer for the given OrgID
 *
 * @param {String} orgId - data from the API response
 * @param {Object} responseData - data from the API response
 *
 * @returns {Array} - ModelList transformer that converts API data into Product models
 */

const getTransformedProducts = (orgId, responseData) => {
  return responseData.map(responseItem => {
    var _a;

    const product = new Product_1.Product(Object.assign(Object.assign({}, responseItem), {
      orgId
    }));
    product.licenseGroupSummaries = (_a = product.licenseGroupSummaries) === null || _a === void 0 ? void 0 : _a.map(profile => new LicenseGroup_1.LicenseGroup(Object.assign(Object.assign({}, profile), {
      orgId,
      product
    })));
    return product;
  });
};